export { headerFooterDisplayItem, addDisplayTranslations } from "./Display";
/**
 * @deprecated: It's no longer needed to manually mount this component.
 * @see: https://components.react-dsfr.codegouv.studio/?path=/docs/components-display
 */
export function Display() {
    return null;
}
//# sourceMappingURL=index.js.map